import { render, staticRenderFns } from "./detail_product_page.vue?vue&type=template&id=188fe794&scoped=true"
import script from "./detail_product_page.vue?vue&type=script&lang=js"
export * from "./detail_product_page.vue?vue&type=script&lang=js"
import style0 from "./detail_product_page.vue?vue&type=style&index=0&id=188fe794&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188fe794",
  null
  
)

export default component.exports